(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvEntitySelector', drvEntitySelector);

    drvEntitySelector.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvEntitySelector
     *
     * @description
     * A component used for selecting an entity from the supplied list of entities.
     *
     * # Scope Params
     * {string} label - The label/name to be shown for the control. Optional.
     * {string} icon - The icon to be shown for the control. Optional.
     * {string} iconColour - The icon colour to be shown for the control. Optional.
     * {object} ngModel - The selected value.
     * {array} entityList - List of entities which will be shown by the select control
     * {string} placeHolder - The label/name to be shown in the control when no value has been selected. Optional.
     * {bool} disabled - Disables the control. Optional.
     * {bool} mandatory - Value must be selected. Optional.
     * {bool} disableClear - Disallows the controls value to be cleared. This only works for 'single-select mode'. Optional.
     * {function} onChange - Callback which is invoked when the ng model value has changed. Optional
     * {array/string} valueProperties - Can be array for multiple properties or string for a single property.
     *                                  They will be used to construct a custom value object, this is the format which will be used with ngModel.
     *                                  If not supplied, the unmodified item will be used. Optional.
     */
    function drvEntitySelector() {
        var directive = {
            restrict: 'E',
            controller: drvEntitySelectorCtrl,
            controllerAs: 'drvCtrl',
            scope: {},
            bindToController: {
                label: '@?',
                icon: '@?',
                iconColour: '@?',
                value: '=ngModel',
                selectedEntity: '=',
                entityList: '<',
                placeHolder: '@?',
                disabled: '<?',
                disableClear: '<?',
                mandatory: '<?',
                valueProperties: '<?',
                onChange: '&?',
            },
            template:
                '<drv-selector value="drvCtrl.value" items="drvCtrl.entityList" label="{{drvCtrl.label}}" icon="{{drvCtrl.icon}}" icon-colour="{{drvCtrl.iconColour}}" place-holder="{{drvCtrl.placeHolder ? drvCtrl.placeHolder : \' \'}}" ng-required="drvCtrl.mandatory" value-properties="drvCtrl.valueProperties" search-properties="[\'PreviewNameText\', \'PreviewDescriptionText\']" on-change="drvCtrl.onChange()" disabled="drvCtrl.disabled" disable-clear="drvCtrl.disableClear">' +
                '   <selected-template>' +
                '       <drv-entity-preview entity="item" show-condensed="true"></drv-entity-preview>' +
                '   </selected-template>' +
                '   <dropdown-item-template>' +
                '       <drv-entity-preview class="sub-view-list" entity="item"></drv-entity-preview>' +
                '       <md-divider></md-divider>' +
                '   </dropdown-item-template>' +
                '</drv-selector>'
        };

        drvEntitySelectorCtrl.$inject = [];

        return directive;

        function drvEntitySelectorCtrl() {
            /* jshint validthis:true */
            var drvCtrl = this;

            activate();

            function activate() {

            }
        }
    }
})();